<template>
    <div>
        <b-overlay :show="isBusy" rounded="sm" >
            <b-form @submit="onSubmitEditLocation" novalidate>
                <b-card no-body>
                    <b-tabs small card>
                        <b-tab title="Location">
                            <b-form-group
                                label="Location Name:"
                                label-for="location_name">
                                <b-form-input
                                    id="location_name"
                                    v-model="location.name"
                                    type="text"
                                    placeholder="Enter Location Name"
                                    :disabled="!wantEdit">
                                </b-form-input>
                            </b-form-group>
                            <b-row>
                                <b-col md="4">
                                    <b-form-group
                                        label="Phone Number:"
                                        label-for="location_phone">
                                        <b-form-input
                                            id="location_phone"
                                            v-model="location.phone"
                                            type="text"
                                            placeholder="Enter Phone Number"
                                            :disabled="!wantEdit">
                                        </b-form-input>
                                    </b-form-group>            
                                </b-col>
                                <b-col md="8">
                                    <b-form-group
                                        label="HomeUrl:"
                                        label-for="location_homeUrl">
                                        <b-form-input
                                            id="location_homeUrl"
                                            v-model="location.homeUrl"
                                            type="url"
                                            placeholder="Enter home Url" :disabled="!wantEdit">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-form-group
                                label="Address:"
                                label-for="location_address">
                                <b-form-textarea
                                    id="location_address"
                                    v-model="location.address"
                                    placeholder="Enter Address"
                                    rows="3" :disabled="!wantEdit">
                                </b-form-textarea>
                            </b-form-group>
                            <b-row>
                                <b-col md="4">
                                    <b-form-group
                                        label="City:"
                                        label-for="location_city">
                                        <b-form-input
                                            id="location_city"
                                            v-model="location.city"
                                            type="text"
                                            placeholder="Enter City Name" :disabled="!wantEdit">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4">
                                    <b-form-group
                                        label="State:"
                                        label-for="location_state">
                                        <b-form-input
                                            id="location_state"
                                            v-model="location.state"
                                            type="text"
                                            placeholder="Enter State Name" :disabled="!wantEdit">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4">
                                    <b-form-group
                                        label="ZipCode:"
                                        label-for="location_zipcode">
                                        <b-form-input
                                            id="location_zipcode"
                                            v-model="location.zipCode"
                                            type="text"
                                            placeholder="Enter ZipCode Number" :disabled="!wantEdit">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>                                
                            </b-row>                            
                            <b-row>
                                <b-col md="6">
                                    <b-form-group
                                        label="TaxName1:"
                                        label-for="location_taxname1">
                                        <b-form-input
                                            id="location_taxname1"
                                            v-model="location.taxName1"
                                            type="text"
                                            placeholder="Enter Tax's Name" :disabled="!wantEdit">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group
                                        label="Tax1:"
                                        label-for="location_tax1">
                                        <b-form-input
                                            id="location_tax1"
                                            v-model="tax1"
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            placeholder="Enter Tax1" :disabled="!wantEdit">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group
                                        label="TaxName2:"
                                        label-for="location_taxname2">
                                        <b-form-input
                                            id="location_taxname2"
                                            v-model="location.taxName2"
                                            type="text"
                                            placeholder="Enter Tax's Name" :disabled="!wantEdit">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group
                                        label="Tax2:"
                                        label-for="location_tax2">
                                        <b-form-input
                                            id="location_tax2"
                                            v-model="tax2"
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            placeholder="Enter Tax2" :disabled="!wantEdit">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Setup">
                            <b-form-group
                                label="Friendly Id:"
                                label-for="location_friendlyId">
                                <b-form-input
                                    id="location_friendlyId"
                                    v-model="location.friendlyId"
                                    type="text"
                                    placeholder="Enter Friendly Id"
                                    :disabled="!canSysAdmin(userInfo) || !wantEdit">
                                </b-form-input>
                            </b-form-group>
                            <b-row class="mb-3">
                                <b-col md="4">
                                    <b-form-checkbox
                                        v-model="location.enable"
                                        value="true"
                                        unchecked-value="false" :disabled="!wantEdit">
                                        Enable
                                    </b-form-checkbox>
                                </b-col>
                                <b-col md="4">
                                    <b-form-checkbox
                                        v-model="location.customerLogging"
                                        value="true"
                                        unchecked-value="false" :disabled="!wantEdit">
                                        Customer Logging
                                    </b-form-checkbox>
                                </b-col>
                                <b-col md="4">
                                    <b-form-checkbox
                                        v-model="location.debugPayment"
                                        value="true"
                                        unchecked-value="false" :disabled="!wantEdit">
                                        Debug Payment
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>  
                            <b-row>
                                <b-col md="6">
                                    <b-form-group
                                        label="TimeZone:"
                                        label-for="location_timeZone">                          
                                        <b-form-select 
                                                id="location_timeZone"
                                                v-model="location.timeZone"
                                                :options="timeZones" size="sm" :disabled="!wantEdit">                                
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group
                                        label="Payment System:"
                                        label-for="location_paymentSystem">                          
                                        <b-form-select 
                                                id="location_paymentSystem"
                                                v-model="location.paymentSystem"
                                                :options="paymentSystems" size="sm" :disabled="!wantEdit">                                
                                        </b-form-select>                                        
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Hours">
                            <b-row>
                                <b-col md="6">
                                    <location-hours-day 
                                        v-model="location.hours.monday"
                                        dayTitle="Monday"
                                        :wantEdit="wantEdit" />
                                </b-col>      
                                <b-col md="6">                  
                                    <location-hours-day 
                                        v-model="location.hours.tuesday"
                                        dayTitle="Tuesday"
                                        :wantEdit="wantEdit" />
                                </b-col>      
                                <b-col md="6">
                                    <location-hours-day 
                                        v-model="location.hours.wednesday"
                                        dayTitle="Wednesday"
                                        :wantEdit="wantEdit" />
                                </b-col>      
                                <b-col md="6">
                                    <location-hours-day 
                                        v-model="location.hours.thursday"
                                        dayTitle="Thursday"
                                        :wantEdit="wantEdit" />
                                </b-col>      
                                <b-col md="6">
                                    <location-hours-day 
                                        v-model="location.hours.friday"
                                        dayTitle="Friday"
                                        :wantEdit="wantEdit" />
                                </b-col>      
                                <b-col md="6">
                                    <location-hours-day 
                                        v-model="location.hours.saturday"
                                        dayTitle="Saturday"
                                        :wantEdit="wantEdit" />
                                </b-col>      
                                <b-col md="12">
                                    <location-hours-day 
                                        v-model="location.hours.sunday"
                                            dayTitle="Sunday"
                                        :wantEdit="wantEdit" />
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Tips">
                            <b-row class="justify-content-md-center">
                                <b-col md="6">
                                    <b-form-group
                                        label="Fixed Tip for Under:"
                                        label-for="location_tipRules_limit">
                                        <b-form-input
                                            id="location_tipRules_limit"
                                            :value="$c2d(location.tipRules.limit)"
                                            @change="location.tipRules.limit = $d2c($event)"
                                            type="number"
                                            :min="0"
                                            step="0.01"
                                            placeholder="Enter Amount"
                                            :disabled="!wantEdit">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6" class="border border-secondary">
                                    <span class="text-info">Fixed Tip for Under {{$c2d(location.tipRules.limit) | currency}}</span>
                                    <div v-for="(amount, index) in location.tipRules.amounts" :key="index">
                                        <b-form-group																	
                                            :label="'Tip Amount #' + (index + 1)"
                                            :label-for="'location_tipRules_amount_' + (index + 1)">
                                            <b-form-input
                                                :id="'location_tipRules_amount_' + (index + 1)"
                                                type="number"
                                                :min="0"
                                                step="0.01"
                                                :value="$c2d(amount)"
                                                @change="location.tipRules.amounts[index] = $d2c($event)"
                                                placeholder="Enter Amount"
                                                :disabled="!wantEdit">
                                            </b-form-input>
                                        </b-form-group>            
                                    </div>
                                </b-col>
                                <b-col md="6" class="border border-secondary">
                                    <span class="text-info">Percetage tips for Over {{$c2d(location.tipRules.limit) | currency}}</span>
                                    <div v-for="(percent, index) in location.tipRules.percents" :key="index">
                                        <b-form-group																	
                                            :label="'Tip Percent #' + (index + 1)"
                                            :label-for="'location_tipRules_percent_' + (index + 1)">
                                            <b-form-input
                                                :id="'location_tipRules_percent_' + (index + 1)"
                                                type="number"
                                                :min="0"
                                                :max="100"
                                                step="0.01"										
                                                :value="$c2d(percent)"
                                                @change="location.tipRules.percents[index] = $d2c($event)"
                                                placeholder="Enter Percent"
                                                :disabled="!wantEdit">
                                            </b-form-input>
                                        </b-form-group>            
                                    </div>
                                </b-col>
                            </b-row>                   
                        </b-tab>
                        <b-tab title="Work Flow">
                            <b-row>
                                <b-col md="6">
                                    <b-form-checkbox v-model="location.preparingEnabled" 
                                        switch
                                        :disabled="!wantEdit">
                                        Preparing
                                    </b-form-checkbox>
                                </b-col>
                                <b-col md="6">
                                    <b-form-checkbox v-model="location.packEnabled" 
                                        switch
                                        :disabled="!wantEdit">
                                        Pack
                                    </b-form-checkbox>
                                </b-col>
                                <b-col md="6">
                                    <b-form-checkbox v-model="location.readyEnabled" 
                                        switch
                                        :disabled="!wantEdit">
                                        Ready
                                    </b-form-checkbox>
                                </b-col>
                                <b-col md="6">
                                    <b-form-checkbox v-model="location.closeEnabled" 
                                        :disabled="!canSysAdmin(userInfo) || !wantEdit"
                                        switch>
                                        Close
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <hr/>
                            <b-row class="mt-3">
                                
                                <b-col md="6">
                                    <b-form-group label="Auto Reject Time:" label-for="location_auto_reject_time">
                                        <b-form-select 
                                            id="location_auto_reject_time"
                                            v-model="location.autoRejectTime"
                                            :options="rejectTimeSlot"
                                            :disabled="!wantEdit"
                                            size="sm" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Default Time:" label-for="location_default_time">
                                        <b-form-select 
                                            id="location_default_time"
                                            v-model="location.defaultTime"
                                            :options="defaultTimeSlot"
                                            :disabled="!wantEdit"
                                            size="sm" />
                                    </b-form-group>							
                                </b-col>			

                                <b-col md="6">
                                    <b-form-checkbox v-model="location.estimateCompletion" 
                                        switch
                                        :disabled="!wantEdit">
                                        Estimated Completion
                                    </b-form-checkbox>
                                </b-col>
                                <b-col md="6">
                                    <b-form-checkbox v-model="location.allowCancel" 
                                        switch
                                        :disabled="!wantEdit">
                                        Allow Customer Cancel								
                                    </b-form-checkbox>
                                </b-col>			
                            </b-row>
                            <hr/>
                            <b-row class="mt-3">
                                <b-col md="6">
                                    <b-form-checkbox v-model="location.sendConfirmSMS" 
                                        switch
                                        :disabled="!wantEdit">
                                        Send Confirm/Reject SMS
                                    </b-form-checkbox>
                                </b-col>
                                <b-col md="6">
                                    <b-form-checkbox v-model="location.sendReadySms" 
                                        switch
                                        :disabled="!wantEdit">
                                        Send Ready SMS							
                                    </b-form-checkbox>
                                </b-col>	
                            </b-row>
                        </b-tab>
                        <b-tab title="Banners">
                            <b-row class="m-0" v-if="wantEdit">
                                <b-col md="12" class="p-0">
                                    <vue-dropzone
                                        :options="dropzoneOptions"
                                        :include-styling="true"
                                        v-on:vdropzone-thumbnail="thumbnail"
                                        id="customdropzone"
                                        ref="customdropzone"
                                        @vdropzone-complete="fileComplete"
                                        @vdropzone-duplicate="fileDuplicate"
                                        :duplicateCheck="true" />
                                </b-col>
                            </b-row>
                            <div v-for="(banner, $index) in location.banners" :key="$index">
                                <b-img-lazy :src="banner" class="img-full-width" />
                                <div class="text-right">
                                    <button 
                                        :disabled="!wantEdit"
                                        class="btn btn-link btn-sm"
                                        @click="deleteBanner($index)"
                                        type="button">
                                        <i class="fa fa-trash" />
                                    </button>                                   
                                </div>
                                <hr/>
                            </div>
                        </b-tab>
                        <b-tab title="Macros">
                            <b-form-group                                
                                label="Macros:"
                                label-for="location_macro">
                                <b-form-textarea
                                    :disabled="!wantEdit"
                                    id="location_macro"
                                    v-model.trim="location.macros"
                                    rows="20"
                                    placeholder="Macros">
                                </b-form-textarea>
                            </b-form-group>
                        </b-tab>
                    </b-tabs>
                </b-card>

                <div class="text-right" v-if="wantEdit">
                    <span class="text-danger"> {{submitError}} </span>
                    <b-button type="submit" v-if="confirmTitle" variant="primary" right>{{confirmTitle}}</b-button>
                </div>
            </b-form>
        </b-overlay>
    </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Swal from 'sweetalert2'

import { mapState } from 'vuex'
import _timezones from "@/assets/json/timezones.json"//http://worldtimeapi.org/
import LocationHoursDay from "@/components/portal/LocationHoursDay"
const moment = require('moment-timezone');

let validateLocationHours = (hours) => {
	let {monday, tuesday, wednesday, thursday, friday,  saturday, sunday} = hours;
	const displayFormat = "hh:mma";

	let dateRange = (day, dayOfWeek, format) => {
		let dateRanges = [];
		day.forEach((hour) => {
			let {startTime, endTime} = typeof(hour) === "object" ? hour : JSON.parse(hour);
			let stTime = moment(startTime, displayFormat);
			let enTime = moment(endTime, displayFormat);
			if(stTime.isValid() && enTime.isValid()) {
				stTime = stTime.day(dayOfWeek);
				enTime = enTime.day(dayOfWeek);
				if(stTime.isAfter(enTime)){
					enTime.add(1, "days");
				}
				if(format){
					dateRanges.push({ startTime : stTime.format(displayFormat), endTime : enTime.format(displayFormat) });
				}else{
					dateRanges.push({ startTime : stTime, endTime : enTime });
				}
			}
		});
		return dateRanges;
	}

	let isValidate = (dateRanges) => {
		let previous = null;
		let index = 0;
		for (let t of dateRanges) {
            if (previous && (!t.startTime || !previous.endTime || t.startTime.isBefore(previous.endTime))) {
                return index;
            }
            index++;
            previous = t;
        }
        return -1;
	}

	let dateRanges = [];
	dateRanges.push(...dateRange(sunday, 0, false));
	dateRanges.push(...dateRange(monday, 1, false));
	dateRanges.push(...dateRange(tuesday, 2, false));
	dateRanges.push(...dateRange(wednesday, 3, false));
	dateRanges.push(...dateRange(thursday, 4, false));
	dateRanges.push(...dateRange(friday, 5, false));
	dateRanges.push(...dateRange(saturday, 6, false));
	dateRanges.push(...dateRange(sunday, 7, false));
	
	let inValidIndex = isValidate(dateRanges);

	if (inValidIndex >= 0) {
		let dateRange = dateRanges[inValidIndex];		
		let startTimeString = !dateRange.startTime ? "" : dateRange.startTime.format("dddd hh:mma");
		let endTimeString = !dateRange.endTime ? "" : dateRange.endTime.format(displayFormat);
		let msg = !startTimeString || !endTimeString ? "Invalid Input" : `Overlaping to ahead time of ${startTimeString}-${endTimeString}`;
		return { sts : false, msg : msg };
	}

	let newHours = { monday:[], tuesday:[], wednesday:[], thursday:[], friday:[],  saturday:[], sunday:[] }
	newHours.monday.push(...dateRange(monday, 1, true));
	newHours.tuesday.push(...dateRange(tuesday, 2, true));
	newHours.wednesday.push(...dateRange(wednesday, 3, true));
	newHours.thursday.push(...dateRange(thursday, 4, true));
	newHours.friday.push(...dateRange(friday, 5, true));
	newHours.saturday.push(...dateRange(saturday, 6, true));
	newHours.sunday.push(...dateRange(sunday, 7, true));
	return { sts : true , newHours : newHours };
}

const rejectTimeSlot = new Array(7).fill(1).map((x, index) =>{
	if(index == 0){
		return { value : 0, text : "Never" }
	}
		return { value : index * 5, text : `${index * 5} Minutes` }
});
const defaultTimeSlot = new Array(9).fill(1).map((x, index) => { return { value : (index + 1) * 5,  text : `${(index + 1) * 5} Minutes` } });


export default {
    name : 'Location',
    components:{ LocationHoursDay, vueDropzone: vue2Dropzone},

    props : {
        isBusy : { type : Boolean, default : false },
        confirmTitle : {type : String, default : null},
        cancelTitle : {type : String, default : null},        
        wantEdit : {type : Boolean, default : true},
        value : { type : Object },
    },
    data() { 
        let apiPath = "api/media/upload-media"
        return { 
            submitError : "",
            rejectTimeSlot : rejectTimeSlot,
            defaultTimeSlot : defaultTimeSlot,
            location : null,
            paymentSystems:[{ text:"Square", value:"square" }, { text:"Stripe", value:"stripe" }],
            timeZones:_timezones,
                   
            dropzoneOptions: {
                url: apiPath ,
                thumbnailWidth: 200,
                addRemoveLinks: true,
                autoQueue: true,
                accept: function(file, done) {
                    if (!file.type.startsWith("image")) {
                        done("Error! Files of this type are not accepted");
                    }
                    else { done(); }
                }
            }
        
    }},
    computed : {
        ...mapState({ userInfo: 'userInfo' }),
        tax1:{
            get() {
               return this.location.tax / 100.0
            },
            set(newVale) {
                this.location.tax = Math.round(newVale * 100.0)
            }
        },
        tax2:{
            get() {
               return this.location.tax2 / 100.0
            },
            set(newVale) {
                this.location.tax2 = Math.round(newVale * 100.0)
            }
        },
        
    },
    watch : {
        value:{
            deep:true,
            immediate:true,
            handler(newValue){
                this.location = newValue;
                this.setDefault();
            }
        }
    },
    created() { 
        
    },
    mounted() {
        this.$nextTick(() => {
            this.location = this.value;
            this.setDefault();
        })
    },
    destroyed() { },
    methods: { 
        setDefault() {
            if(this.location && !this.location.tipRules){
                this.location.tipRules = { amounts : [], percents : [], limit : 0 }
            }
            if(this.location && !this.location.paymentSystem){
                this.location.paymentSystem = "square";
            }
            if(this.location && !this.location.timeZone){
                this.location.timeZone = "America/New_York";
            }
            if(this.location && !this.location.hours){
                this.location.hours = { monday:[], tuesday:[], wednesday:[], thursday:[], friday:[], saturday:[], sunday:[] }
            }
            if(this.location && !this.location.autoRejectTime){
                this.location.autoRejectTime = 0;
            }
            if(this.location && !this.location.defaultTime){
                this.location.defaultTime = 15;
            }
            
            const amounts = this.location.tipRules.amounts;
			for(let i = amounts.length; i < 3; i++){
				this.location.tipRules.amounts.push(0);
			}
			const percents = this.location.tipRules.percents;
			for(let i = percents.length; i < 3; i++){
				this.location.tipRules.percents.push(0);
            }
        },
        onSubmitEditLocation(event){
            event.preventDefault()
            this.submitError = "";
            let {name, friendlyId, hours} = this.location

            if(!name){
                this.submitError = "Location's Name Require";
                return;
            }
            if(!friendlyId) {
                this.submitError = "Setup's FriendlyId Require";
                return;
            }
            let {sts, msg, newHours} = validateLocationHours(hours);            
            if(!sts){
                this.submitError = msg;
                return;
            } else {
                this.location.hours = newHours;
            }     

            this.$emit("onSubmitLocation", this.location)
        },
        deleteBanner(index) {
            this.$delete(this.location.banners, index)
        },

        fileComplete(file) {
            let {status, response, responseText} = file.xhr;
            if(status === 200) {
                let {url} = JSON.parse(response);
                this.location.banners.push(url); 
            } else {
                Swal.fire({ icon: 'error', html: responseText })
            }
            this.$refs.customdropzone.removeFile(file);
        },
        fileDuplicate(){
            this.toast(this, { msg: `Duplicate Image found` })
        },
        template: function () {
            return `<div class="dz-preview dz-file-preview">
                    <div class="dz-image">
                        <div data-dz-thumbnail-bg></div>
                    </div>
                    <div class="dz-details">
                        <div class="dz-size"><span data-dz-size></span></div>
                        <div class="dz-filename"><span data-dz-name></span></div>
                    </div>
                    <!--<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>-->
                    <div class="dz-error-message"><span data-dz-errormessage></span></div>
                    <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                    <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                    </div>
            `;
        },
        thumbnail: function(file, dataUrl) {
            var j, len, ref, thumbnailElement;
            if (file.previewElement) {
                file.previewElement.classList.remove("dz-file-preview");
                ref = file.previewElement.querySelectorAll("[data-dz-thumbnail-bg]");
                for (j = 0, len = ref.length; j < len; j++) {
                    thumbnailElement = ref[j];
                    thumbnailElement.alt = file.name;
                    thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
                }
                return setTimeout(((function() {
                    return function() {
                        return file.previewElement.classList.add("dz-image-preview");
                    };
                })(this)), 1);
            }
        },
     },
}
</script>
<style scoped lang="scss">
    .img-full-width {
        width: 100%;
    }
</style>